import React from 'react'
import { Modal, ModalCloseButton } from '@grupoboticario/flora-react-modal'
import { Flex } from '@grupoboticario/flora-react-flex'
import { Text } from '@grupoboticario/flora-react-text'
import { CheckCircleFillIcon } from '@grupoboticario/flora-react-icons'

import * as S from './styles'
import { FeedbackCsatProps } from './types'
import { scores, Steps, defaultTexts } from './data'
import { useController } from './useController'

export const FeedbackCsat = ({
  texts,
  onClose,
  onOpen,
  onSubmit,
  open,
  autoClose = false,
  autoCloseTimeout = 5_000,
}: FeedbackCsatProps) => {
  const {
    comment,
    step,
    isOpen,
    onSelectScore,
    onChangeComment,
    onSubmitComment,
    onOpenChange,
    requiredComment,
    commentTextKey,
  } = useController({ onClose, onOpen, onSubmit, open, autoClose, autoCloseTimeout })

  return (
    <Modal open={isOpen} onOpenChange={onOpenChange}>
      <S.Content size="small" data-flora="feedback-csat">
        <S.Header>
          <Flex justify="space-between">
            <S.Title bold={step !== Steps.Score} level={6}>
              {step === Steps.Score && texts.score.title}
              {step === Steps.Comment && texts.comment[commentTextKey].title}
              {step === Steps.Done && (
                <>
                  <CheckCircleFillIcon color="$success-standard" />
                  {texts.done?.title ?? defaultTexts.done.title}
                </>
              )}
            </S.Title>

            <ModalCloseButton />
          </Flex>
        </S.Header>

        <S.Body>
          {step === Steps.Score && (
            <Flex css={S.scoreButtonsContainer}>
              {scores.map(({ Icon, ...score }) => (
                <S.ScoreButton key={score.value} onClick={() => onSelectScore(score.value)}>
                  <S.CheckCircleFillIcon>
                    <Icon />
                  </S.CheckCircleFillIcon>
                  <span>{score.label}</span>
                </S.ScoreButton>
              ))}
            </Flex>
          )}

          {step === Steps.Comment && (
            <>
              <Text as="p" size="bodyMediumStandard">
                {texts.comment[commentTextKey].description}
              </Text>
              <S.Comment
                id="comment"
                required={requiredComment}
                label={texts.comment.placeholder ?? defaultTexts.comment.placeholder}
                onChange={onChangeComment}
              />
              <S.SubmitButton onClick={onSubmitComment} disabled={requiredComment && !comment}>
                {texts.comment.button ?? defaultTexts.comment.button}
              </S.SubmitButton>
            </>
          )}

          {step === Steps.Done && (
            <Text as="p" size="bodyMediumStandard">
              {texts.done?.description ?? defaultTexts.done.description}
            </Text>
          )}
        </S.Body>
      </S.Content>
    </Modal>
  )
}
